// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tower-clock"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M18 16H16V22H8V16H6V6H9V3.125L12 2L15 3.125V6H18V16Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 16V22H8V16M16 16H18V6H6V16H8M16 16H12M8 16H12M12 16V19M8 3.5L12 2L16 3.5M9 6V3.65M15 3.65V6","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TowerClockIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tower-clock',
    ref,
    icon: element,
  },
));

TowerClockIcon.displayName = 'TowerClockIcon';

export default TowerClockIcon;
